import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
import React, {forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState} from 'react'


export const SlashCommandMenu = forwardRef(
  (
    props


,
    ref
  ) => {
    const {items} = props
    const [selectedIndex, setSelectedIndex] = useState(0)
    const activeRef = useRef(null)
    const flatItems = items.flatMap((item) => item.commands)
    const activeItem = flatItems[selectedIndex]
    const selectItem = (title) => {
      const item = flatItems.find((item) => item.title === title)
      if (!item) return
      const {action} = item
      props.command({action})
    }

    const upHandler = () => {
      setSelectedIndex((selectedIndex + flatItems.length - 1) % flatItems.length)
    }

    const downHandler = () => {
      setSelectedIndex((selectedIndex + 1) % flatItems.length)
    }

    const enterHandler = () => {
      const title = flatItems[selectedIndex].title
      selectItem(title)
    }

    useEffect(() => setSelectedIndex(0), [items])
    useEffect(() => {
      _optionalChain([activeRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.scrollIntoView, 'call', _3 => _3({block: 'nearest'})])
    }, [activeRef.current])
    useImperativeHandle(ref, () => ({
      onKeyDown: ({event}) => {
        if (event.key === 'ArrowUp') {
          upHandler()
          return true
        }

        if (event.key === 'ArrowDown') {
          downHandler()
          return true
        }

        if (event.key === 'Enter' || event.key === 'Tab') {
          enterHandler()
          return true
        }
        return false
      }
    }))

    if (!items.length) return null
    return (
      _jsx('div', { className: "z-10 max-h-56 overflow-auto rounded-md bg-white py-1 shadow-lg outline-hidden in-data-[placement=\"bottom-start\"]:animate-slide-down in-data-[placement=\"top-start\"]:animate-slide-up"         , children: 
        items.map((item) => (
          _jsxs(Fragment, { children: [
            _jsx('div', { className: "mx-1 px-3 py-1 text-xs font-semibold"    , children: item.group})
            , item.commands.map((command) => (
              _jsx('div', { className: "mx-1 flex" , children: 
                _jsxs('div', {
                  ref: command === activeItem ? activeRef : undefined,
                  'data-highlighted': command === activeItem ? '' : undefined,
                  className: 
                    'group flex w-full cursor-pointer items-center space-x-2 rounded-md px-3 py-2 text-sm leading-8 text-slate-700 outline-hidden hover:bg-slate-200! hover:text-slate-900 focus:bg-slate-200 data-highlighted:bg-slate-100 data-highlighted:text-slate-900'
                  ,
                  onClick: () => selectItem(command.title),
 children: [
                  _jsx('div', { className: "flex size-7 items-center justify-center rounded-sm bg-slate-200 group-hover:bg-slate-300 group-data-highlighted:bg-slate-300"       , children: 
                    _jsx(command.icon, { className: "size-5",} )
                  })
                  , _jsxs('div', { className: "flex flex-col text-sm"  , children: [
                    _jsx('span', { children: command.title})
                    , _jsx('span', { className: "text-xs text-slate-600" , children: command.description})
                  ]})
                ]})
              }, command.title)
            ))
          ]}, item.group)
        ))
      })
    )
  }
)
